export default __webpack_public_path__ + "static/media/get-started-step-1.61fc64f8.png";